import { useSignup } from '../hooks/use-signup';
import { SignupForm } from '@/components/organisms/forms/signup-form';
import type { SignupFormData } from '@/lib/validations';

export function SignupContainer() {
  const { signup, isLoading, error, clearError } = useSignup();

  const handleSubmit = async (data: SignupFormData) => {
    await signup({
      name: data.name,
      email: data.email,
      birthday: data.birthday,
      password: data.password,
      address: {
        countryIsoCode3: data.countryIsoCode3,
        countryName: data.countryName,
        city: data.city,
        postal_code: data.postalCode || undefined,
        address_line1:
          (data.address && data.address.trim()) ||
          (data.landmark && data.landmark.trim()) ||
          data.city.trim(),
        address_line2: data.addressLine2 || undefined,
        landmark: data.landmark || undefined,
        latitude: data.latitude,
        longitude: data.longitude,
      },
    });
  };

  return (
    <SignupForm
      onSubmit={handleSubmit}
      isLoading={isLoading}
      error={error}
      onErrorClear={clearError}
    />
  );
}
